import { RESUME_VOLUME_WORK_VIEW } from '@/fixtures'

export default {
  path: 'summary-resume-volume-work',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Kemajuan Pekerjaan',
      component: () => import('@/views/menus/SummaryResumeVolumeWork/Index'),
      meta: {
        permission: RESUME_VOLUME_WORK_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Kemajuan Pekerjaan',
      component: () => import('@/views/menus/SummaryResumeVolumeWork/View'),
      meta: {
        permission: RESUME_VOLUME_WORK_VIEW
      }
    }
  ]
}
